import axios from "axios";
import { ApiKey, BaseUrl } from "../global";


export const getIsUserCreationValid = async (loggedInUser, userId, accountNo, branchCode, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/userManagement/isusercreationvalid' + `?loggedInUser=${loggedInUser}&userId=${userId}&accountNo=${accountNo}&branchCode=${branchCode}`, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

export const createZaUser = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/userManagement/CreateZAUser', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return [];
    }
}

